(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mobile-fullscreen-video')) {
      customElements.define(
        'mobile-fullscreen-video',
        class extends HTMLElement {
          connectedCallback() {
            this.addEventListener('pointerdown', this.trackFullscreenPointer);
            this.addEventListener('click', this.handleFullscreenRequest);
          }

          disconnectedCallback() {
            this.removeEventListener('pointerdown', this.trackFullscreenPointer);
            this.removeEventListener('click', this.handleFullscreenRequest);
          }

          trackFullscreenPointer(event) {
            this.fullscreenPointerType = event.pointerType;
          }

          handleFullscreenRequest(event) {
            const pointerType = this.fullscreenPointerType || event.pointerType;
            this.fullscreenPointerType = null;

            if (event.detail === 0 || (pointerType !== 'touch' && pointerType !== 'pen')) {
              return;
            }

            if (!this.hasAttribute('mobile-fullscreen-on-tap') || !window.matchMedia('(max-width: 699px)').matches) {
              return;
            }

            if (!(event.target instanceof Element)) {
              return;
            }

            if (event.target.closest('a, button, input, select, textarea, summary, [role="button"]')) {
              return;
            }

            const video = Array.from(this.querySelectorAll('video')).find((item) => item.getClientRects().length > 0);

            if (!video) {
              return;
            }

            const controlsWereVisible = video.controls;
            const mutedWasEnabled = video.muted;
            const shouldResumePlayback = !video.paused;
            const resumeTimers = [];
            let exitHandled = false;
            let resumeWindowOpen = false;

            const resumePlayback = () => {
              if (!resumeWindowOpen || !shouldResumePlayback || !video.isConnected) {
                return;
              }

              video.autoplay = true;
              video.muted = mutedWasEnabled;
              video.defaultMuted = mutedWasEnabled;

              const playPromise = video.play();

              if (playPromise) {
                playPromise.catch(() => {});
              }
            };

            const handleLatePause = () => {
              if (resumeWindowOpen) {
                resumeTimers.push(setTimeout(resumePlayback, 0));
              }
            };

            const cleanupExitListeners = () => {
              resumeWindowOpen = false;
              video.removeEventListener('pause', handleLatePause);
              video.removeEventListener('webkitendfullscreen', handleFullscreenExit);
              video.removeEventListener('webkitpresentationmodechanged', handlePresentationModeChange);
              document.removeEventListener('fullscreenchange', handleFullscreenChange);
              resumeTimers.forEach((timer) => clearTimeout(timer));
            };

            const handleFullscreenExit = () => {
              if (exitHandled) {
                return;
              }

              exitHandled = true;
              resumeWindowOpen = true;
              video.controls = controlsWereVisible;
              video.addEventListener('pause', handleLatePause);
              resumePlayback();

              [100, 300, 700, 1200].forEach((delay) => {
                resumeTimers.push(setTimeout(resumePlayback, delay));
              });

              resumeTimers.push(setTimeout(cleanupExitListeners, 2000));
            };

            const handlePresentationModeChange = () => {
              if (video.webkitPresentationMode === 'inline') {
                handleFullscreenExit();
              }
            };

            const handleFullscreenChange = () => {
              if (!document.fullscreenElement) {
                handleFullscreenExit();
              }
            };

            video.controls = true;

            try {
              if (typeof video.webkitEnterFullscreen === 'function') {
                video.addEventListener('webkitendfullscreen', handleFullscreenExit);
                video.addEventListener('webkitpresentationmodechanged', handlePresentationModeChange);
                video.webkitEnterFullscreen();
              } else if (typeof video.requestFullscreen === 'function') {
                document.addEventListener('fullscreenchange', handleFullscreenChange);
                video.requestFullscreen().catch(handleFullscreenExit);
              } else {
                handleFullscreenExit();
              }
            } catch {
              handleFullscreenExit();
            }
          }
        }
      );
  }

  } catch(e) { console.error(e); }
})();
})();
